import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { cisloBankyRegExp } from 'enums/regExp';

// Calculate suma for the modulus 11 from a string.
// str - String dlouhy maximalne 10 znaku.
// ctrl - String obsahuje kontrolni cislici nebo ne.
const calculateSumaModulus11 = (str: string, ctrl: boolean) => {
    const weights = [1, 2, 4, 8, 5, 10, 9, 7, 3, 6];
    let tmp = str.length - (ctrl ? 1 : 0);
    let sum = 0;
    for (let i = 0; i < str.length; i++) sum += (Number(str.charAt(i)) - 0) * weights[tmp - i];
    return sum;
};

// Kontrola cisla bankovniho uctu
// 0 - OK
// 1 - E: nezadano
// 2 - E: chybna syntaxe
// 3 - E: chybna kontrolka
// 4 - E: ucet je nulovy
const checkBankAccount = (str: string) => {
    if (!str) return 1; // nezadano
    if (!/^[0-9]{2,10}$/.test(str)) return 2; // chybna syntaxe
    const sum = calculateSumaModulus11(str, true);
    if (sum % 11 != 0) return 3; // chybna kontrolka
    if (sum == 0) return 4; // ucet je nulovy
    return 0;
};

// Kontrola prefixu bankovniho ucttu
// 0 - OK
// 1 - E: nezadano
// 2 - E: chybna syntaxe
// 3 - E: chybna kontrolka
// 4 - W: prefix je nulovy
const checkBankPrefix = (str: string) => {
    if (!str) return 1; // nezadano
    if (!/^[0-9]{0,6}$/.test(str)) return 2; // chybna syntaxe
    const sum = calculateSumaModulus11(str, true);
    if (sum % 11 != 0) return 3; // chybna kontrolka
    if (sum == 0) return 4; // prefix je nulovy
    return 0;
};

export const predcisliValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if ((checkBankPrefix(value) !== 3 && checkBankPrefix(value) !== 2) || !value) return Promise.resolve();
            return Promise.reject(<TranslateText>INVALID_PREDCISLI</TranslateText>);
        }
    })
];
export const cisloUctuValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (checkBankAccount(value) === 0 || !value) return Promise.resolve();
            return Promise.reject(<TranslateText>INVALID_CISLOUCTU</TranslateText>);
        }
    })
];
export const kodBankyValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (cisloBankyRegExp.test(value) || !value) return Promise.resolve();
            return Promise.reject(<TranslateText>INVALID_KODBANKY</TranslateText>);
        }
    })
];
